import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hideDialog } from '../actions';
import ModalDialog from './Modal';
import NoteForm from './NoteForm';

class NoteDialog extends Component {
  static propTypes = {
    title: PropTypes.string,
    triggerSubmit: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    closeDialog: PropTypes.func.isRequired,
    onReady: PropTypes.func.isRequired,
  };

  formRef = React.createRef();

  onReady = () => {
    if (this.formRef.current && this.formRef.current.submit) {
      this.formRef.current.submit();
    }
  };

  onSubmit = (values) => {
    const data = {
      note: values,
    };

    this.props.onReady(data);
  };

  render() {
    const { closeDialog, isOpen, title } = this.props;
    return (
      <ModalDialog title={title} onReady={this.onReady} isOpen={isOpen} close={closeDialog}>
        <NoteForm ref={this.formRef} onSubmit={this.onSubmit} />
      </ModalDialog>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeDialog: hideDialog,
    },
    dispatch
  );
};

export default connect(null, mapDispatchToProps)(NoteDialog);
